import React from 'react'

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

const Link = ({ href, download, children, target, style, ...props }) => {
  return jwtToken ? (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      style={style}
      onClick={() => window?.ReactNativeWebView?.postMessage?.(href)}
      href="#"
    >
      {children}
    </a>
  ) : (
    <a style={style} target={target} download={download} href={href} {...props}>
      {children}
    </a>
  )
}

export default Link
